var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22179 11.1582L1.2925 11.0875L1.22179 11.1582L9.53179 19.4682C10.0608 19.9973 10.9142 19.9973 11.4432 19.4682C11.9723 18.9392 11.9723 18.0858 11.4432 17.5568L4.27387 10.3775L11.4532 3.19821C11.9722 2.67917 11.9724 1.8156 11.4429 1.29646C10.9138 0.767737 10.0607 0.767847 9.53179 1.29679L1.22179 9.60679C0.792737 10.0358 0.792737 10.7292 1.22179 11.1582Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackWhite);
export default __webpack_public_path__ + "static/media/backWhite.bdfeef0c6886a07927a92271862df354.svg";
export { ForwardRef as ReactComponent };